module.exports = __webpack_public_path__ + "img/McD_Instore_Fullscreenimages_01.78ddca4b.jpg";